//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ScenariosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    startScenario(scenarioId: string, request: ScenarioStartRequest): Promise<ScenarioStartResponse> {
        let url_ = this.baseUrl + "/api/scenarios/{scenarioId}/start";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartScenario(_response);
        });
    }

    protected processStartScenario(response: Response): Promise<ScenarioStartResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScenarioStartResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScenarioStartResponse>(null as any);
    }

    getInstanceStatus(scenarioId: string): Promise<StatusResponse> {
        let url_ = this.baseUrl + "/api/scenarios/{scenarioId}/status";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInstanceStatus(_response);
        });
    }

    protected processGetInstanceStatus(response: Response): Promise<StatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatusResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusResponse>(null as any);
    }

    getScenarios(sort: string[] | undefined): Promise<ScenarioListResponse> {
        let url_ = this.baseUrl + "/api/scenarios?";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScenarios(_response);
        });
    }

    protected processGetScenarios(response: Response): Promise<ScenarioListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScenarioListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScenarioListResponse>(null as any);
    }

    getScenario(scenarioId: string): Promise<Scenario> {
        let url_ = this.baseUrl + "/api/scenarios/{scenarioId}";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScenario(_response);
        });
    }

    protected processGetScenario(response: Response): Promise<Scenario> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Scenario.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Scenario>(null as any);
    }

    deleteScenario(scenarioId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/scenarios/{scenarioId}";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteScenario(_response);
        });
    }

    protected processDeleteScenario(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getScenarioPublicData(scenarioId: string): Promise<ScenarioPublicData> {
        let url_ = this.baseUrl + "/api/scenarios/{scenarioId}/public";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScenarioPublicData(_response);
        });
    }

    protected processGetScenarioPublicData(response: Response): Promise<ScenarioPublicData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScenarioPublicData.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScenarioPublicData>(null as any);
    }

    sendInstanceEvent(scenarioId: string, sessionId: string, instanceEvent: InstanceEvent): Promise<void> {
        let url_ = this.baseUrl + "/api/scenarios/{scenarioId}/{sessionId}/event";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instanceEvent);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendInstanceEvent(_response);
        });
    }

    protected processSendInstanceEvent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    saveInstanceChanges(scenarioId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/scenarios/{scenarioId}/save";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveInstanceChanges(_response);
        });
    }

    protected processSaveInstanceChanges(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    saveAsNew(scenarioId: string, request: ScenarioSaveAsNewRequest): Promise<ScenarioSaveAsNewResult> {
        let url_ = this.baseUrl + "/api/scenarios/{scenarioId}/save/new";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveAsNew(_response);
        });
    }

    protected processSaveAsNew(response: Response): Promise<ScenarioSaveAsNewResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScenarioSaveAsNewResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScenarioSaveAsNewResult>(null as any);
    }

    downloadScenario(scenarioId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/scenarios/{scenarioId}/package";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadScenario(_response);
        });
    }

    protected processDownloadScenario(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportScenarioToPdf(scenarioId: string, width: number | undefined, height: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/scenarios/{scenarioId}/export/pdf?";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        if (width === null)
            throw new Error("The parameter 'width' cannot be null.");
        else if (width !== undefined)
            url_ += "width=" + encodeURIComponent("" + width) + "&";
        if (height === null)
            throw new Error("The parameter 'height' cannot be null.");
        else if (height !== undefined)
            url_ += "height=" + encodeURIComponent("" + height) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportScenarioToPdf(_response);
        });
    }

    protected processExportScenarioToPdf(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createScenario(presentationName: string, iFormFile: Blob): Promise<FileUploadResponse> {
        let url_ = this.baseUrl + "/api/scenarios/{presentationName}";
        if (presentationName === undefined || presentationName === null)
            throw new Error("The parameter 'presentationName' must be defined.");
        url_ = url_.replace("{presentationName}", encodeURIComponent("" + presentationName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = iFormFile;

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateScenario(_response);
        });
    }

    protected processCreateScenario(response: Response): Promise<FileUploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileUploadResponse>(null as any);
    }

    getScenarioPassword(scenarioId: string): Promise<ScenarioPasswordResponse> {
        let url_ = this.baseUrl + "/api/scenarios/{scenarioId}/password";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScenarioPassword(_response);
        });
    }

    protected processGetScenarioPassword(response: Response): Promise<ScenarioPasswordResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScenarioPasswordResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScenarioPasswordResponse>(null as any);
    }

    setScenarioPassword(scenarioId: string, request: ScenarioPasswordUpdateRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/scenarios/{scenarioId}/password";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetScenarioPassword(_response);
        });
    }

    protected processSetScenarioPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setScenarioCloneability(scenarioId: string, request: ScenarioCloneabilityChangeRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/scenarios/{scenarioId}/cloneability";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetScenarioCloneability(_response);
        });
    }

    protected processSetScenarioCloneability(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CustomLinksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createCustomLink(customLink: CustomLink): Promise<void> {
        let url_ = this.baseUrl + "/api/custom-links";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customLink);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCustomLink(_response);
        });
    }

    protected processCreateCustomLink(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getCustomLinks(sort: string[] | undefined): Promise<CustomLinkListResponse> {
        let url_ = this.baseUrl + "/api/custom-links?";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomLinks(_response);
        });
    }

    protected processGetCustomLinks(response: Response): Promise<CustomLinkListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomLinkListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomLinkListResponse>(null as any);
    }

    editCustomLink(linkId: string, link: CustomLink): Promise<void> {
        let url_ = this.baseUrl + "/api/custom-links/{linkId}";
        if (linkId === undefined || linkId === null)
            throw new Error("The parameter 'linkId' must be defined.");
        url_ = url_.replace("{linkId}", encodeURIComponent("" + linkId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(link);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditCustomLink(_response);
        });
    }

    protected processEditCustomLink(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteCustomLink(linkId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/custom-links/{linkId}";
        if (linkId === undefined || linkId === null)
            throw new Error("The parameter 'linkId' must be defined.");
        url_ = url_.replace("{linkId}", encodeURIComponent("" + linkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCustomLink(_response);
        });
    }

    protected processDeleteCustomLink(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AuthenticationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    login(loginRequest: LoginRequest): Promise<User> {
        let url_ = this.baseUrl + "/api/authentication/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    logout(): Promise<void> {
        let url_ = this.baseUrl + "/api/authentication/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getCurrentUser(): Promise<UserResponse> {
        let url_ = this.baseUrl + "/api/authentication/currentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentUser(_response);
        });
    }

    protected processGetCurrentUser(response: Response): Promise<UserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserResponse>(null as any);
    }

    getToken(): Promise<OneTimeTokenResponse> {
        let url_ = this.baseUrl + "/api/authentication/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetToken(_response);
        });
    }

    protected processGetToken(response: Response): Promise<OneTimeTokenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OneTimeTokenResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OneTimeTokenResponse>(null as any);
    }

    getAvailableProviders(): Promise<AuthenticationProviderClientConfig[]> {
        let url_ = this.baseUrl + "/api/authentication/AvailableProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableProviders(_response);
        });
    }

    protected processGetAvailableProviders(response: Response): Promise<AuthenticationProviderClientConfig[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthenticationProviderClientConfig.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthenticationProviderClientConfig[]>(null as any);
    }
}

export class GeneralClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getVersion(): Promise<VersionResponse> {
        let url_ = this.baseUrl + "/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersion(_response);
        });
    }

    protected processGetVersion(response: Response): Promise<VersionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VersionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionResponse>(null as any);
    }
}

export class ScenarioStartResponse implements IScenarioStartResponse {
    scenarioId?: string | undefined;
    scenarioStatus?: ScenarioStatus;

    constructor(data?: IScenarioStartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.scenarioStatus = _data["scenarioStatus"];
        }
    }

    static fromJS(data: any): ScenarioStartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioStartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["scenarioStatus"] = this.scenarioStatus;
        return data;
    }
}

export interface IScenarioStartResponse {
    scenarioId?: string | undefined;
    scenarioStatus?: ScenarioStatus;
}

export enum ScenarioStatus {
    Started = 0,
    AlreadyRunning = 1,
    NoContent = 2,
}

export class ScenarioStartRequest implements IScenarioStartRequest {
    password?: string;

    constructor(data?: IScenarioStartRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ScenarioStartRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioStartRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        return data;
    }
}

export interface IScenarioStartRequest {
    password?: string;
}

export class StatusResponse implements IStatusResponse {
    status?: InstanceStatus;

    constructor(data?: IStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): StatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface IStatusResponse {
    status?: InstanceStatus;
}

export enum InstanceStatus {
    Starting = 0,
    Ready = 1,
    Occupied = 2,
    Error = 3,
}

export class ScenarioListResponse implements IScenarioListResponse {
    results!: ScenarioWithFiles[];

    constructor(data?: IScenarioListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new ScenarioWithFiles(item) : <ScenarioWithFiles>item;
                }
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ScenarioWithFiles.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScenarioListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScenarioListResponse {
    results: IScenarioWithFiles[];
}

export class ScenarioWithFiles implements IScenarioWithFiles {
    files?: ScenarioFiles;
    passwordProtected?: boolean;
    ownerName?: string;
    updatedBy?: string | undefined;
    updatedAt?: Date | undefined;
    createdAt?: Date;
    canBeModified?: CanBeModified;
    ownerId?: string;
    name?: string;
    presentationGuid?: string;
    id?: string;
    embedId?: string;
    sharedWith?: string | undefined;
    cloneable?: boolean;

    constructor(data?: IScenarioWithFiles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.files = data.files && !(<any>data.files).toJSON ? new ScenarioFiles(data.files) : <ScenarioFiles>this.files;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.files = _data["files"] ? ScenarioFiles.fromJS(_data["files"]) : <any>undefined;
            this.passwordProtected = _data["passwordProtected"];
            this.ownerName = _data["ownerName"];
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.canBeModified = _data["canBeModified"];
            this.ownerId = _data["ownerId"];
            this.name = _data["name"];
            this.presentationGuid = _data["presentationGuid"];
            this.id = _data["id"];
            this.embedId = _data["embedId"];
            this.sharedWith = _data["sharedWith"];
            this.cloneable = _data["cloneable"];
        }
    }

    static fromJS(data: any): ScenarioWithFiles {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioWithFiles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["files"] = this.files ? this.files.toJSON() : <any>undefined;
        data["passwordProtected"] = this.passwordProtected;
        data["ownerName"] = this.ownerName;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["canBeModified"] = this.canBeModified;
        data["ownerId"] = this.ownerId;
        data["name"] = this.name;
        data["presentationGuid"] = this.presentationGuid;
        data["id"] = this.id;
        data["embedId"] = this.embedId;
        data["sharedWith"] = this.sharedWith;
        data["cloneable"] = this.cloneable;
        return data;
    }
}

export interface IScenarioWithFiles {
    files?: IScenarioFiles;
    passwordProtected?: boolean;
    ownerName?: string;
    updatedBy?: string | undefined;
    updatedAt?: Date | undefined;
    createdAt?: Date;
    canBeModified?: CanBeModified;
    ownerId?: string;
    name?: string;
    presentationGuid?: string;
    id?: string;
    embedId?: string;
    sharedWith?: string | undefined;
    cloneable?: boolean;
}

export class ScenarioFiles implements IScenarioFiles {
    presentationFiles?: string[];
    dataFiles?: string[];

    constructor(data?: IScenarioFiles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["presentationFiles"])) {
                this.presentationFiles = [] as any;
                for (let item of _data["presentationFiles"])
                    this.presentationFiles!.push(item);
            }
            if (Array.isArray(_data["dataFiles"])) {
                this.dataFiles = [] as any;
                for (let item of _data["dataFiles"])
                    this.dataFiles!.push(item);
            }
        }
    }

    static fromJS(data: any): ScenarioFiles {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioFiles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.presentationFiles)) {
            data["presentationFiles"] = [];
            for (let item of this.presentationFiles)
                data["presentationFiles"].push(item);
        }
        if (Array.isArray(this.dataFiles)) {
            data["dataFiles"] = [];
            for (let item of this.dataFiles)
                data["dataFiles"].push(item);
        }
        return data;
    }
}

export interface IScenarioFiles {
    presentationFiles?: string[];
    dataFiles?: string[];
}

export enum CanBeModified {
    No = 0,
    Owner = 1,
    FirstOpener = 2,
}

export class Scenario implements IScenario {
    id!: string;
    embedId!: string;
    ownerId!: string;
    presentationGuid!: string;
    name!: string;
    canBeModified?: CanBeModified;
    createdAt!: Date;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;
    password?: string | undefined;
    slideCount!: number;
    chartCount!: number;
    sharedWith?: string | undefined;
    cloneable?: boolean;
    clonedFrom?: string | undefined;

    constructor(data?: IScenario) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.embedId = _data["embedId"];
            this.ownerId = _data["ownerId"];
            this.presentationGuid = _data["presentationGuid"];
            this.name = _data["name"];
            this.canBeModified = _data["canBeModified"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.password = _data["password"];
            this.slideCount = _data["slideCount"];
            this.chartCount = _data["chartCount"];
            this.sharedWith = _data["sharedWith"];
            this.cloneable = _data["cloneable"];
            this.clonedFrom = _data["clonedFrom"];
        }
    }

    static fromJS(data: any): Scenario {
        data = typeof data === 'object' ? data : {};
        let result = new Scenario();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["embedId"] = this.embedId;
        data["ownerId"] = this.ownerId;
        data["presentationGuid"] = this.presentationGuid;
        data["name"] = this.name;
        data["canBeModified"] = this.canBeModified;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["password"] = this.password;
        data["slideCount"] = this.slideCount;
        data["chartCount"] = this.chartCount;
        data["sharedWith"] = this.sharedWith;
        data["cloneable"] = this.cloneable;
        data["clonedFrom"] = this.clonedFrom;
        return data;
    }
}

export interface IScenario {
    id: string;
    embedId: string;
    ownerId: string;
    presentationGuid: string;
    name: string;
    canBeModified?: CanBeModified;
    createdAt: Date;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;
    password?: string | undefined;
    slideCount: number;
    chartCount: number;
    sharedWith?: string | undefined;
    cloneable?: boolean;
    clonedFrom?: string | undefined;
}

export class ScenarioPublicData implements IScenarioPublicData {
    id!: string;
    cloneable?: boolean;

    constructor(data?: IScenarioPublicData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cloneable = _data["cloneable"];
        }
    }

    static fromJS(data: any): ScenarioPublicData {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioPublicData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cloneable"] = this.cloneable;
        return data;
    }
}

export interface IScenarioPublicData {
    id: string;
    cloneable?: boolean;
}

export abstract class InstanceEvent implements IInstanceEvent {
    createdAt?: Date;

    constructor(data?: IInstanceEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InstanceEvent {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'InstanceEvent' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IInstanceEvent {
    createdAt?: Date;
}

export class ScenarioSaveAsNewResult implements IScenarioSaveAsNewResult {
    copiedScenarioId!: string;

    constructor(data?: IScenarioSaveAsNewResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.copiedScenarioId = _data["copiedScenarioId"];
        }
    }

    static fromJS(data: any): ScenarioSaveAsNewResult {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioSaveAsNewResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["copiedScenarioId"] = this.copiedScenarioId;
        return data;
    }
}

export interface IScenarioSaveAsNewResult {
    copiedScenarioId: string;
}

export class ScenarioSaveAsNewRequest implements IScenarioSaveAsNewRequest {
    requester?: string;

    constructor(data?: IScenarioSaveAsNewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requester = _data["requester"];
        }
    }

    static fromJS(data: any): ScenarioSaveAsNewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioSaveAsNewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requester"] = this.requester;
        return data;
    }
}

export interface IScenarioSaveAsNewRequest {
    requester?: string;
}

export class FileUploadResponse implements IFileUploadResponse {
    scenarioId?: string;
    error?: string;

    constructor(data?: IFileUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): FileUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["error"] = this.error;
        return data;
    }
}

export interface IFileUploadResponse {
    scenarioId?: string;
    error?: string;
}

export class ScenarioPasswordResponse implements IScenarioPasswordResponse {
    password?: string | undefined;

    constructor(data?: IScenarioPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ScenarioPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        return data;
    }
}

export interface IScenarioPasswordResponse {
    password?: string | undefined;
}

export class ScenarioPasswordUpdateRequest implements IScenarioPasswordUpdateRequest {
    password?: string | undefined;

    constructor(data?: IScenarioPasswordUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ScenarioPasswordUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioPasswordUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        return data;
    }
}

export interface IScenarioPasswordUpdateRequest {
    password?: string | undefined;
}

export class ScenarioCloneabilityChangeRequest implements IScenarioCloneabilityChangeRequest {
    isCloneable?: boolean;

    constructor(data?: IScenarioCloneabilityChangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCloneable = _data["isCloneable"];
        }
    }

    static fromJS(data: any): ScenarioCloneabilityChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioCloneabilityChangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCloneable"] = this.isCloneable;
        return data;
    }
}

export interface IScenarioCloneabilityChangeRequest {
    isCloneable?: boolean;
}

export class CustomLink implements ICustomLink {
    id!: string;
    name!: string;
    ownerId!: string;
    createdAt!: Date;
    updatedAt?: Date | undefined;
    presentationId?: string | undefined;
    description?: string | undefined;
    embedId?: string | undefined;

    constructor(data?: ICustomLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.ownerId = _data["ownerId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.presentationId = _data["presentationId"];
            this.description = _data["description"];
            this.embedId = _data["embedId"];
        }
    }

    static fromJS(data: any): CustomLink {
        data = typeof data === 'object' ? data : {};
        let result = new CustomLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ownerId"] = this.ownerId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["presentationId"] = this.presentationId;
        data["description"] = this.description;
        data["embedId"] = this.embedId;
        return data;
    }
}

export interface ICustomLink {
    id: string;
    name: string;
    ownerId: string;
    createdAt: Date;
    updatedAt?: Date | undefined;
    presentationId?: string | undefined;
    description?: string | undefined;
    embedId?: string | undefined;
}

export class CustomLinkListResponse implements ICustomLinkListResponse {
    results?: CustomLinkWithOwnerName[];

    constructor(data?: ICustomLinkListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new CustomLinkWithOwnerName(item) : <CustomLinkWithOwnerName>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CustomLinkWithOwnerName.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomLinkListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomLinkListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomLinkListResponse {
    results?: ICustomLinkWithOwnerName[];
}

export class CustomLinkWithOwnerName implements ICustomLinkWithOwnerName {
    id?: string | undefined;
    name?: string | undefined;
    ownerId?: string | undefined;
    ownerName?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date | undefined;
    presentationId?: string | undefined;
    description?: string | undefined;
    embedId?: string | undefined;

    constructor(data?: ICustomLinkWithOwnerName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.ownerId = _data["ownerId"];
            this.ownerName = _data["ownerName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.presentationId = _data["presentationId"];
            this.description = _data["description"];
            this.embedId = _data["embedId"];
        }
    }

    static fromJS(data: any): CustomLinkWithOwnerName {
        data = typeof data === 'object' ? data : {};
        let result = new CustomLinkWithOwnerName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ownerId"] = this.ownerId;
        data["ownerName"] = this.ownerName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["presentationId"] = this.presentationId;
        data["description"] = this.description;
        data["embedId"] = this.embedId;
        return data;
    }
}

export interface ICustomLinkWithOwnerName {
    id?: string | undefined;
    name?: string | undefined;
    ownerId?: string | undefined;
    ownerName?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date | undefined;
    presentationId?: string | undefined;
    description?: string | undefined;
    embedId?: string | undefined;
}

export class User implements IUser {
    id?: string;
    name!: string;
    authenticator!: string;
    email?: string | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.authenticator = _data["authenticator"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["authenticator"] = this.authenticator;
        data["email"] = this.email;
        return data;
    }
}

export interface IUser {
    id?: string;
    name: string;
    authenticator: string;
    email?: string | undefined;
}

export class LoginRequest implements ILoginRequest {
    azure?: AzureActiveDirectoryToken | undefined;
    credentials?: UserCredentials | undefined;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.azure = data.azure && !(<any>data.azure).toJSON ? new AzureActiveDirectoryToken(data.azure) : <AzureActiveDirectoryToken>this.azure;
            this.credentials = data.credentials && !(<any>data.credentials).toJSON ? new UserCredentials(data.credentials) : <UserCredentials>this.credentials;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.azure = _data["azure"] ? AzureActiveDirectoryToken.fromJS(_data["azure"]) : <any>undefined;
            this.credentials = _data["credentials"] ? UserCredentials.fromJS(_data["credentials"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["azure"] = this.azure ? this.azure.toJSON() : <any>undefined;
        data["credentials"] = this.credentials ? this.credentials.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILoginRequest {
    azure?: IAzureActiveDirectoryToken | undefined;
    credentials?: IUserCredentials | undefined;
}

export class AzureActiveDirectoryToken implements IAzureActiveDirectoryToken {
    token?: string;

    constructor(data?: IAzureActiveDirectoryToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): AzureActiveDirectoryToken {
        data = typeof data === 'object' ? data : {};
        let result = new AzureActiveDirectoryToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IAzureActiveDirectoryToken {
    token?: string;
}

export class UserCredentials implements IUserCredentials {
    name?: string;

    constructor(data?: IUserCredentials) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserCredentials {
        data = typeof data === 'object' ? data : {};
        let result = new UserCredentials();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IUserCredentials {
    name?: string;
}

export class UserResponse implements IUserResponse {
    user?: User;

    constructor(data?: IUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserResponse {
    user?: IUser;
}

export class OneTimeTokenResponse implements IOneTimeTokenResponse {
    token?: string;

    constructor(data?: IOneTimeTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): OneTimeTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OneTimeTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IOneTimeTokenResponse {
    token?: string;
}

export class AuthenticationProviderClientConfig implements IAuthenticationProviderClientConfig {
    type?: string;
    parameters?: { [key: string]: any; };

    constructor(data?: IAuthenticationProviderClientConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
        }
    }

    static fromJS(data: any): AuthenticationProviderClientConfig {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationProviderClientConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        return data;
    }
}

export interface IAuthenticationProviderClientConfig {
    type?: string;
    parameters?: { [key: string]: any; };
}

export class VersionResponse implements IVersionResponse {
    id?: string;
    version?: string;

    constructor(data?: IVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): VersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["version"] = this.version;
        return data;
    }
}

export interface IVersionResponse {
    id?: string;
    version?: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}